import { render, staticRenderFns } from "./AnnotationHighlighter.vue?vue&type=template&id=baa3b70e&scoped=true"
import script from "./AnnotationHighlighter.vue?vue&type=script&lang=js"
export * from "./AnnotationHighlighter.vue?vue&type=script&lang=js"
import style0 from "./AnnotationHighlighter.vue?vue&type=style&index=0&id=baa3b70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3b70e",
  null
  
)

export default component.exports